import { Maybe } from 'graphql/jsutils/Maybe';
import { chain, range } from 'lodash';

export const MAIN_FOOD_ITEM_PAIRING_LIMIT = 3;
export const PAIRING_LIMIT = 7;

export const FOOD_ITEM_INPUT_SELECTOR = {
  ALLERGEN: {
    DAIRY: 'food-item-allergen-dairy',
    EGGS: 'food-item-allergen-eggs',
    GLUTEN: 'food-item-allergen-gluten',
    NUTS: 'food-item-allergen-nuts',
    SOY: 'food-item-allergen-soy',
    SHELLFISH: 'food-item-allergen-shellfish',
  },
  DIETARY: {
    HALAL: 'food-item-dietary-halal',
    KETO: 'food-item-dietary-keto',
    KOSHER: 'food-item-dietary-kosher',
    LOW_FODMAP: 'food-item-dietary-low-fodmap',
    LOW_SODIUM: 'food-item-dietary-low-sodium',
    ORGANIC: 'food-item-dietary-organic',
    PALEO: 'food-item-dietary-paleo',
    SUGAR_FREE: 'food-item-dietary-sugar-free',
    VEGAN: 'food-item-dietary-vegan',
    VEGETARIAN: 'food-item-dietary-vegetarian',
    WHOLE_30: 'food-item-dietary-whole-30',
  },
  FOOD_TYPE: {
    BASE: 'food-item-food-type',
    MAIN: 'food-item-food-type-main',
    APPETIZER: 'food-item-food-type-appetizer',
    BEVERAGE: 'food-item-food-type-beverage',
    DESSERT: 'food-item-food-type-dessert',
    KIDS: 'food-item-food-type-kids',
    SIDE: 'food-item-food-type-side',
  },
  CAPACITY: 'food-item-capacity',
  DESCRIPTION: 'food-item-description',
  EXPIRES: 'food-item-num-days-before-expires',
  IMAGE: 'food-item-image',
  INGREDIENTS: 'food-item-ingredients',
  INSTRUCTIONS: 'food-item-prep-instructions',
  NAME: 'food-item-name',
  PRICE: 'food-item-price',
  SERVING_SIZE: 'food-item-serving-size',
  SPICE_LEVEL: {
    BASE: 'food-item-spice-level',
    NOT_SPICY: 'food-item-spice-level-not-spicy',
    MILD: 'food-item-spice-level-not-mild',
    MEDIUM: 'food-item-spice-level-not-medium',
    HOT: 'food-item-spice-level-not-hot',
  },
  TAGS: 'food-item-tags',
};

// Generates a URL version of a food name
// THIS LOGIC IS DUPLICATED IN OUR food_items ETL TABLE. If you update the logic please also update the ETL here:
// https://github.com/shefhq/shef-etl/blob/2538fae7da/models/analytics/full_refresh/food_items.sql#L8
export function generateFoodNameSlug({ id, name }: { id: number; name?: Maybe<string> }): string {
  return name
    ? `${name
        .replace(/[^0-9a-zA-Z_ ]/g, '')
        .replace(/\s+/g, '-')
        .toLowerCase()}-${id}`
    : '';
}

export const convertServingSizeToRange = (servingSize: string | undefined | null): number[] => {
  const [start, end] = chain(servingSize)
    .replace(/[^0-9-]/g, '') // removes all non-numeric characters apart from '-'
    .split('-') // split '2-4' into ['2', '4']
    .filter((num) => num !== undefined && num !== '')
    .map(Number)
    .value();

  const servingSizeOptions = range(start, 1 + (end ?? start)); // [2, 4] => range(2, 5) => [2, 3, 4]

  return servingSizeOptions;
};
